import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Skeleton, Alert } from "@mui/material";
import { reportByYear } from "../../features/reports/reportsSlice";

const EventsByYear = () => {
    const { isLoading } = useSelector(state => state.progress);
    const [data, setData] = useState({ report: [], types: [], total: 0 })
    const [status, setStatus] = useState('idle');
    const dispatch = useDispatch();
    useEffect(() => {
        if(status === 'idle') reportByYear(dispatch, setData, setStatus)
    }, [status, dispatch])
    return(
        <Container component={Paper} sx={{ p: '2em', mb: '2em' }} maxWidth='xl'>
            <Typography variant="h5" gutterBottom>REPORTE DE EVENTOS POR AÑO</Typography>
            { isLoading ? <Skeleton animation='wave' height={200} /> : data.total > 0 ? (
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Año</TableCell>
                                { data.types.length ? data.types.map((t, i) => <TableCell key={i} align="center" sx={{ fontSize: '0.6em' }}>{t?.nombre}</TableCell>) : null }
                                <TableCell align="center">Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { data.report.map(({ year, data, total }, i) => (
                                <TableRow key={i}>
                                    <TableCell><b>{year}</b></TableCell>
                                    {data.map((e, i) => <TableCell key={i} align="center">{e.total}</TableCell>)}
                                    <TableCell align="center"><b>{total}</b></TableCell>
                                </TableRow>
                            )) }
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <TableCell>TOTAL</TableCell>
                                { data.types.length ? data.types.map((t, i) => <TableCell key={i} align="center"><b>{t?.total}</b></TableCell>) : null }
                                <TableCell align="center"><b>{data.total}</b></TableCell>
                            </TableRow>
                        </TableHead>
                    </Table>
                </TableContainer>
            ) : <Alert severity="warning">No se encontraron resultados</Alert>}
        </Container>
    )
}

export default EventsByYear;